/**
 * Query params for service relations.
 * Note: relation indexes intentionally follow backend expectation.
 */
export const SERVICE_RELATIONS = {
  "relations[0]": "author",
  "relations[1]": "status",
  "relations[2]": "serviceCategory",
};

export const buildServiceRelationParams = () => ({ ...SERVICE_RELATIONS });

/** Create/edit invoice — only approved, active services (see API contract). */
export const buildInvoiceServiceListParams = () => ({
  "relations[0]": "author",
  "relations[2]": "status",
  "conditions[is_approved]": 1,
  status: "Active",
});
